"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M9.475 21.75c.183.167.4.25.65.25h3.75c.25 0 .467-.083.65-.25a.997.997 0 0 0 .325-.625l.3-2.325c.2-.083.4-.183.6-.3.2-.117.392-.242.575-.375l2.125.9c.233.1.47.108.713.025.241-.083.429-.233.562-.45l1.85-3.2a.94.94 0 0 0 .125-.7.96.96 0 0 0-.375-.6l-1.875-1.425c.033-.117.05-.23.05-.338v-.675c0-.108-.008-.22-.025-.337L21.35 9.9a.96.96 0 0 0 .375-.6.94.94 0 0 0-.125-.7l-1.85-3.225a.983.983 0 0 0-.55-.438.97.97 0 0 0-.7.038l-2.175.9a8.229 8.229 0 0 0-.563-.375 3.795 3.795 0 0 0-.612-.3l-.3-2.325a.997.997 0 0 0-.325-.625.934.934 0 0 0-.65-.25h-3.75a.934.934 0 0 0-.65.25.997.997 0 0 0-.325.625L8.85 5.2c-.2.083-.4.183-.6.3-.2.117-.392.242-.575.375l-2.175-.9a.97.97 0 0 0-.7-.037.983.983 0 0 0-.55.437L2.4 8.6a.94.94 0 0 0-.125.7c.05.25.175.45.375.6l1.875 1.425c-.017.117-.025.23-.025.338v.675c0 .108.008.22.025.337L2.65 14.1a.96.96 0 0 0-.375.6.94.94 0 0 0 .125.7l1.85 3.225a.983.983 0 0 0 .55.438.97.97 0 0 0 .7-.038l2.175-.9c.183.133.37.258.563.375.191.117.395.217.612.3l.3 2.325c.033.25.142.458.325.625Zm5-7.275A3.373 3.373 0 0 1 12 15.5c-.983 0-1.813-.342-2.488-1.025A3.393 3.393 0 0 1 8.5 12c0-.967.337-1.792 1.012-2.475S11.017 8.5 12 8.5c.967 0 1.792.342 2.475 1.025A3.372 3.372 0 0 1 15.5 12c0 .967-.342 1.792-1.025 2.475Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};